import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { FertilizerRecord, Warehouse } from '@/types/Component';
import { toCamel } from 'snake-camel';

type Fertilizer = {
    id: string
    name: string;
    unitName: string;
    warehouseId: string;
    warehouseName: string;
}

@Component({
    components: {
        Modal
    }
})
export default class SelectFertilizers extends Vue {
    private baseUrl = '/warehouses'
    private warehouses: Warehouse[] = []
    private initialWarehouse: Warehouse = {
        id: "",
        name: "",
        chemicals: [],
        fertilizers: [],
        depreciationMaterials: [],
        expendableMaterials: [],
        isHidden: false
    }
    private selectedWarehouse: Warehouse = this.initialWarehouse
    private displayFertilizers: { id: string; name: string; unitName: string; }[] = []
    private selectedFertilizers: Fertilizer[] = []
    private searchWord = ""
    private displayWarehouses: Warehouse[] = []

    @Prop()
    private value!: boolean

    @Prop({
        required: true
    })
    private preSelectItem!: FertilizerRecord[]

    @Emit('input')
    private input(value: boolean) {
        value
    }

    @Emit('close')
    private save() {
        return this.selectedFertilizers.map(fertilizer => ({
            warehouseId: fertilizer.warehouseId,
            warehouseName: fertilizer.warehouseName,
            fertilizerId: fertilizer.id,
            fertilizerName: fertilizer.name,
            fertilizerUnitName: fertilizer.unitName
        }))
    }

    @Emit('cancel')
    private cancel() {
        // 初期化処理
        this.searchWord = ""
        this.displayFertilizers = []
        this.selectedFertilizers = []
        this.selectedWarehouse = this.initialWarehouse
    }

    @Watch('value')
    private onOpenModal() {
        if (this.value) {
            this.searchWord = ""
            this.displayFertilizers = []
            this.selectedFertilizers = []
            this.displayWarehouses = []
            this.selectedWarehouse = this.initialWarehouse
            this.getWarehouses()
        }
    }

    get isModalVisible(): boolean {
        return this.value;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }

    private getWarehouses() {
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=false`).then(ret => {
            this.warehouses = this.displayWarehouses = (toCamel(ret) as { warehouses: Warehouse[] }).warehouses.map(warehouse => ({
                id: warehouse.id,
                name: warehouse.name,
                chemicals: warehouse.chemicals,
                fertilizers: warehouse.fertilizers.map(fertilizer => ({
                    id: fertilizer.id,
                    name: fertilizer.name,
                    unitName: fertilizer.unitName,
                    warehouseId: warehouse.id,
                    warehouseName: warehouse.name
                })),
                depreciationMaterials: warehouse.depreciationMaterials,
                expendableMaterials: warehouse.expendableMaterials,
                isHidden: warehouse.isHidden
            }))
            if (this.preSelectItem?.length) {
                // 渡された農薬を選択済みにする
                this.selectedFertilizers = this.preSelectItem.map(item => ({
                    id: item.fertilizerId,
                    name: item.fertilizerName,
                    unitName: item.fertilizerUnitName,
                    warehouseId: item.warehouseId,
                    warehouseName: item.warehouseName
                }))

                // 最初に選択された倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses.find(warehouse => warehouse.id === this.selectedFertilizers[0]?.warehouseId) || this.initialWarehouse
                this.displayFertilizers = this.selectedWarehouse.fertilizers
            } else {
                // 先頭の倉庫を選択状態にする
                this.selectedWarehouse = this.warehouses[0]
                this.displayFertilizers = this.selectedWarehouse.fertilizers
            }
        })
    }

    private selectWarehouse(warehouse: Warehouse) {
        this.selectedWarehouse = warehouse
        this.displayFertilizers = warehouse.fertilizers
        this.filteringFertilizers()
    }

    private filteringFertilizers() {
        this.displayFertilizers = this.warehouses.find(warehouse => this.selectedWarehouse.id === warehouse.id)?.fertilizers.filter(fertilizer => fertilizer.name.indexOf(this.searchWord) > -1) || []
    }

    private search() {
        this.displayWarehouses = this.warehouses.filter(warehouse => warehouse.fertilizers.filter(fertilizer => fertilizer.name.indexOf(this.searchWord) > -1).length)
        this.filteringFertilizers()
    }
}